import { render } from "./ApplicationTests.vue?vue&type=template&id=71c06876&scoped=true"
import script from "./ApplicationTests.vue?vue&type=script&lang=js"
export * from "./ApplicationTests.vue?vue&type=script&lang=js"

import "./ApplicationTests.vue?vue&type=style&index=0&id=71c06876&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c06876"]])

export default __exports__